module.exports = __webpack_public_path__ + "img/c08_buildingtechvaniswisdom_Normal_ua.39660c55.webp";